export default {
    baseStyle: () => ({
        title: {
            fontSize: 'xs',
            fontWeight: 'bold',
            lineHeight: '100%',
            letterSpacing: '0%',
            textTransform: 'uppercase',
            marginBottom: 2
        },
        content: {
            fontSize: 'xs',
            lineHeight: '15px',
            letterSpacing: '0%'
        },
        showHideCta: {
            fontSize: 'xs',
            lineHeight: '15px',
            letterSpacing: '0%',
            textDecoration: 'underline',
            marginTop: 2
        }
    })
}
